import { render, staticRenderFns } from "./Precos.vue?vue&type=template&id=2aafe666&scoped=true"
import script from "./Precos.vue?vue&type=script&lang=js"
export * from "./Precos.vue?vue&type=script&lang=js"
import style0 from "./Precos.vue?vue&type=style&index=0&id=2aafe666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aafe666",
  null
  
)

export default component.exports